module.exports = __webpack_public_path__ + "static/banner-be4f1df13ae45bf225f5767e96fb82c5.jpg";